import React from "react";
import styled from "styled-components";
import { useWindowSize } from "../../../hooks";
import { Markup } from "interweave";

const ClinicalRequirementsTable = ({ types }) => {
  const { windowWidth } = useWindowSize();
  return (
    <Container>
      {windowWidth >= 780 ? (
        <>
          <h5>Specimen Required</h5>
          <h5>Specimen Container</h5>
          <h5>Storage and Shipment Conditions</h5>
          {types.map((type) => (
            <>
              <p>
                <Markup content={type.specimenRequired} />
              </p>
              <p>
                <Markup content={type.specimenContainer} />
              </p>
              <p>
                <Markup content={type.shippingConditions} />
              </p>
            </>
          ))}
        </>
      ) : (
        <>
          {types.map((type) => (
            <>
              <h5>Specimen Required</h5>
              <p>
                <Markup content={type.specimenRequired} />
              </p>
              <h5>Specimen Container</h5>
              <p>
                <Markup content={type.specimenContainer} />
              </p>
              <h5>Storage and Shipment Condition</h5>
              <p>
                <Markup content={type.shippingConditions} />
              </p>
            </>
          ))}
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;
  h5 {
    font-size: 1rem;
    padding: 1rem 1.25rem;
    &:nth-of-type(3n) {
      border-bottom: 1px solid #e5e5e5;
    }
    &:last-of-type {
        border-bottom: none;
      }
  }
  p {
    padding: 1rem 1.25rem;
      &:nth-child(3n) {
        border-bottom: 1px solid #e5e5e5;
      }
      &:last-of-type {
        border-bottom: none;
      }
  }

  ul {
    margin: 0;
    margin-left: 1rem;
    li {
      margin-bottom: 0.5rem;
    }
  }
  @media screen and (min-width: 780px) {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    h5 {
      &:nth-of-type(3n) {
        border-bottom: none;
      }
      &:not(:last-of-type) {
        border-right: 1px solid #e5e5e5;
      }
    }
    p {
      &:not(:nth-last-child(-n + 3)) {
        border-bottom: 1px solid #e5e5e5;
      }
      &:not(:nth-child(3n)) {
        border-right: 1px solid #e5e5e5;
      }
    }
  }
  @media screen and (min-width: 1024px) {
    margin-left: -1.25rem;
  }
`;

export default ClinicalRequirementsTable;